<ul>
  <li *ngFor="let folder of folders">
    <app-docu-folder-link
      [docuRoot]="docuRoot"
      [folder]="folder"
    ></app-docu-folder-link>
  </li>
</ul>
